import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import useAsyncAction from '../Hooks/useAsyncAction';

// Peringatan idle: tidak bisa ditutup klik luar/Esc — user harus memilih tombol.
const IdleTimeoutModal = ({ isOpen, secondsLeft, onStay, onLogout }) => {
  // Signing out waits for the server call, so show it and ignore repeat clicks.
  const [signOut, signingOut] = useAsyncAction(async () => onLogout());

  return (
    <Modal
      isOpen={isOpen}
      backdrop='static'
      keyboard={false}
      centered
      role='alertdialog'
      labelledBy='idle-timeout-title'
    >
      <ModalHeader tag='h5' id='idle-timeout-title'>
        Are you still there?
      </ModalHeader>
      <ModalBody>
        For your security, you will be signed out in {secondsLeft} seconds due
        to inactivity.
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={signOut} disabled={signingOut}>
          {signingOut ? (
            <Spinner size='sm' className='me-2'>
              Signing out…
            </Spinner>
          ) : (
            <i
              className='ri-logout-box-r-line align-middle me-2'
              aria-hidden='true'
            ></i>
          )}
          Sign out now
        </Button>
        <Button
          color='primary'
          onClick={onStay}
          disabled={signingOut}
          autoFocus
        >
          Stay signed in
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default IdleTimeoutModal;
